import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=bec81e26&scoped=true"
import script from "./RecommendationCard.vue?vue&type=script&lang=js"
export * from "./RecommendationCard.vue?vue&type=script&lang=js"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=bec81e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec81e26",
  null
  
)

export default component.exports